import React from 'react';

const NoMarkets: React.FC = () => {
    return (
        <div className='flex justify-center items-center h-full text-gray-500'>
            Markets not available.
        </div>
    );
};

export default NoMarkets;